/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/page`
 */
export interface RulesSetPageGetRequest {
  /**
   * 场景id
   */
  sceneId?: string;
  /**
   * 所属租户
   */
  mcid?: string;
  /**
   * 名称，模糊查询
   */
  name?: string;
  /**
   * 状态
   */
  status?: string;
  page?: string;
  size?: string;
  id?: string;
  username?: string;
  'authorities[0].role'?: string;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/page`
 */
export interface RulesSetPageGetResponse {
  /**
   * 当前页
   */
  page?: number;
  /**
   * 每页的数量
   */
  size?: number;
  /**
   * 总记录数
   */
  total?: number;
  /**
   * 结果集
   */
  list?: {
    /**
     * 规则集id
     */
    id?: number;
    /**
     * 规则集名称
     */
    name?: string;
    /**
     * 设备数量
     */
    deviceCount?: number;
    /**
     * 租户名称
     */
    tenantName?: string;
    /**
     * 规则集状态
     */
    status?: number;
    /**
     * 规则集场景
     */
    sceneName?: string;
    /**
     * 规则集场景Id
     */
    sceneId?: number;
    /**
     * 属性组名称
     */
    dataPropertyGroupName?: string;
    /**
     * 属性组id
     */
    dataPropertyGroupId?: number;
    /**
     * 封面图片
     */
    imageUri?: string;
  }[];
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/page`
 */
type ApiRulesSetPageGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet/page',
    'retdata',
    string,
    'sceneId' | 'mcid' | 'name' | 'status' | 'page' | 'size' | 'id' | 'username' | 'authorities[0].role',
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/page`
 */
const apiRulesSetPageGetRequestConfig: ApiRulesSetPageGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['sceneId', 'mcid', 'name', 'status', 'page', 'size', 'id', 'username', 'authorities[0].role'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetPageGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/page`
 */
export const apiRulesSetPageGet = /*#__PURE__*/ (requestData: RulesSetPageGetRequest, ...args: UserRequestRestArgs) => {
  return request<RulesSetPageGetResponse>(prepare(apiRulesSetPageGetRequestConfig, requestData), ...args);
};

apiRulesSetPageGet.requestConfig = apiRulesSetPageGetRequestConfig;

/* prettier-ignore-end */
